import { render } from "./createInstructionModal.vue?vue&type=template&id=6a5290da&ts=true"
import script from "./createInstructionModal.vue?vue&type=script&lang=ts"
export * from "./createInstructionModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__